// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.metadata_A8n4i, .noMetadata_QixEN {
  padding : 5px 10px;
  margin-bottom:10px;
  width:100%;
  font-size : 11px;
  color: var( --grey );
  word-break: break-all;
  word-wrap: break-word;
  white-space:pre;
  overflow:auto;
  max-height: 150px;
  max-width:100%;
  width:100%;
  font-family:Courier,Monaco,Menlo,"Ubuntu Mono",Consolas,source-code-pro,monospace;

}`, "",{"version":3,"sources":["webpack://./src/editors/timerAction/style.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,iFAAiF;;AAEnF","sourcesContent":["@import \"../../style/theme.css\";\n\n.metadata, .noMetadata {\n  padding : 5px 10px;\n  margin-bottom:10px;\n  width:100%;\n  font-size : 11px;\n  color: var( --grey );\n  word-break: break-all;\n  word-wrap: break-word;\n  white-space:pre;\n  overflow:auto;\n  max-height: 150px;\n  max-width:100%;\n  width:100%;\n  font-family:Courier,Monaco,Menlo,\"Ubuntu Mono\",Consolas,source-code-pro,monospace;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"metadata": `metadata_A8n4i`,
	"noMetadata": `noMetadata_QixEN`
};
export default ___CSS_LOADER_EXPORT___;
